import { useEffect, useState } from "react";
import { Card, Row, Col } from "antd";
import {
  FaNewspaper,
  FaUserTie,
  FaBuilding,
  FaFileAlt,
  FaFileInvoiceDollar,
  FaHandsHelping,
  FaAward,
  FaRoad,
} from "react-icons/fa";
import axios from "axios";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { useNavigate } from "react-router-dom";

const ICONS = [
  FaNewspaper,
  FaUserTie,
  FaBuilding,
  FaFileAlt,
  FaFileInvoiceDollar,
  FaHandsHelping,
  FaAward,
  FaRoad,
];

const DashboardCards = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchStats = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${BASE_URL}/api/dashboard_stats/stats/latest`);
      setStats(res.data.data || []);
    } catch (error) {
      console.error("FetchStats error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  const StatCards = [
    { title: "News", count: stats?.news || 0, Icon: ICONS[0], path: "/dashboard/news" },
    { title: "Jobs", count: stats?.jobs || 0, Icon: ICONS[1], path: "/dashboard/career" },
    { title: "Management", count: stats?.management || 0, Icon: ICONS[2], path: "/dashboard/management" },
    { title: "Government Document", count: stats?.government_document || 0, Icon: ICONS[3], path: "/dashboard/government-doc" },
    { title: "Investor Document", count: stats?.investor_document || 0, Icon: ICONS[4], path: "/dashboard/investor-doc" },
    { title: "CSR", count: stats?.csr || 0, Icon: ICONS[5], path: "/dashboard/csr" },
    { title: "Awards", count: stats?.awards || 0, Icon: ICONS[6], path: "/dashboard/awards" },
    { title: "Journey", count: stats?.journey || 0, Icon: ICONS[7], path: "/dashboard/journey" },
  ];

  // Data grafik
  const chartData = StatCards.map((card) => ({
    category: card.title,
    value: card.count,
  }));

  if (loading) return <div>Loading...</div>;

  return (
    <>
      <Row gutter={[24, 24]} className="mb-6">
        {StatCards.map((card, index) => (
          <Col key={index} xs={24} sm={12} md={8} lg={6}>
            <Card
              hoverable
              onClick={() => navigate(card.path)}
              className="rounded-2xl shadow-lg transition-transform duration-300 hover:scale-105 cursor-pointer"
              bodyStyle={{ padding: "20px" }}
            >
              <div className="flex items-center gap-4 mb-4">
                <div
                  className="flex items-center justify-center w-12 h-12 rounded-full text-white"
                  style={{ background: "#3a33a3a" }}
                >
                  <card.Icon size={24} style={{ color: "#ec4899" }}/>
                </div>
                <div className="text-lg font-semibold text-gray-700">{card.title}</div>
              </div>
              <div className="text-3xl font-bold text-gray-900">{card.count}</div>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Grafik batang pake Recharts */}
      <Card
        title="Statistics Chart"
        className="rounded-2xl shadow-lg"
        style={{ marginTop: 20 }}
      >
        <ResponsiveContainer width="100%" height={400}>
          <BarChart data={chartData} margin={{ top: 20, right: 30, left: 0, bottom: 20 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="category" angle={0} tick={{ fontSize: 12 }} />
            <YAxis />
            <Tooltip />
            <Bar dataKey="value" fill="#ec4899" radius={[6, 6, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </Card>
    </>
  );
};

export default DashboardCards;
